import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const planTimelineConfigProviderEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "ai-rovo-actions-plan-timeline-config-provider" */ './PlanTimelineConfigProvider'
		).then((module) => module.PlanTimelineConfigProviderEntry),
	),
	getPreloadProps: () => ({}),
});
